module.exports = __webpack_public_path__ + "img/stasis.fcf2cf06.jpg";